query GetRecentEditions($limit: Int!, $dripSequenceId: ID) {
    recentEditions(limit: $limit, id: $dripSequenceId) {
        id
        name
        createdTime
        modifiedTime
        sendTime
        status
        htmlUrlPath
        viewInBrowserLink
        isABTesting
        backgroundColor
        emailTemplate {
            id
            thumbnailUrl
        }
        comparison {
            id
        }
        campaign {
            id
            type
            owner {
                id
                name
            }
        }
    }
}
